import React, { useState } from 'react';

import { Button, Input, Modal, Form, notification, message } from 'antd';
import { observer } from 'mobx-react';

import ContactStore from '../../../stores/ContactStore';

import { FormItemProps } from '@ant-design/compatible/es/form';

import ErrorRender from 'components/shared/ErrorRender';

interface ContactProps {
    record?: {
        id?: number;
        email?: string;
        invoice_email_address?: string;
    };
    updateData?: () => void;
    disabled?: boolean;
}

interface IHandleSubmit {
    preventDefault: () => void;
}

const EditInvoice: React.FC<ContactProps> = props => {
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisible] = useState<boolean>(false);

    const [form] = Form.useForm();

    const showAdd = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    const handleSubmit = async (e: IHandleSubmit) => {
        e.preventDefault();
        form.validateFields()
            .then(async values => {
                setLoading(true);
                if (props.record?.id) {
                    await ContactStore.updateInvoiceInformation(props.record.id, {
                        invoice_email_address: values.invoice_email_address,
                    })
                        .then(() => {
                            setLoading(false);
                            setVisible(false);
                            props.updateData && props.updateData();

                            message.success(`Successfully edited!!!`);
                        })
                        .catch(error => {
                            setLoading(false);

                            notification.error({
                                message: 'Error',
                                description: <ErrorRender error={error} />,
                            });
                        });
                }
            })
            .catch(errorInfo => {
                setLoading(false);

                notification.error({
                    duration: 10,
                    message: 'Error',
                    description: 'Required fields are empty!',
                    placement: 'topRight',
                });
            });
    };

    function handleInvoiceemailAddress(invoice_email_address: string) {
        if (invoice_email_address === null) {
            return props.record?.email;
        } else {
            return props.record?.invoice_email_address;
        }
    }
    const formItemLayout: FormItemProps = {
        labelCol: {
            // xs: { span: 24 },
            // sm: { span: 24 },
            md: { span: 24 },
        },
        wrapperCol: {
            // xs: { span: 24 },
            // sm: { span: 16 },
            md: { span: 24 },
        },
        labelAlign: 'left',
    };

    return (
        <>
            <Button
                data-testid="customer-settings-edit-invoice-btn"
                disabled={props.disabled}
                onClick={showAdd}
                type="primary"
                size="large"
            >
                Modify
            </Button>
            <Modal
                open={visible}
                title="Edit invoice email contact"
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form}>
                    <Form.Item
                        label="Invoice email address"
                        {...formItemLayout}
                        name="invoice_email_address"
                        rules={[{ required: true, message: 'Please input a invoice email address' }, { type: 'email' }]}
                        initialValue={
                            props.record?.invoice_email_address
                                ? handleInvoiceemailAddress(props.record?.invoice_email_address)
                                : ''
                        }
                    >
                        <Input size="large" placeholder="Email address..." />
                    </Form.Item>
                    <div className="flex justify-between mt-5">
                        <Button
                            key="back"
                            onClick={handleCancel}
                            size="large"
                            style={{ color: '#D92923', borderColor: '#D92923' }}
                        >
                            Close
                        </Button>
                        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit} size="large">
                            Submit
                        </Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
};

export default observer(EditInvoice);
